import React, { useState } from 'react'

export default function NewMessage({event, index, onClose, onShowGameModal}) {
  const [showClose, setShowClose] = useState(false)

  const onShowClose = () => {
    setShowClose(true)
  }

  const onHideClose = () => {
    setShowClose(false) 
  }

  return <div className='message' onMouseEnter={onShowClose} onMouseLeave={onHideClose}>
    {showClose &&
      <button className='close' onClick={e => onClose({channel_id: event.channel_id})}>
        <i className= 'fa fa-times'></i>
      </button>
    }
    <div className='text' onClick={e => onShowGameModal({gameId: event.id, activeTab: 'game-messages'})}>
      <b>New Message</b> in {event.date}'s {event.time} {event.name} game
    </div>
  </div>
}
